import { Trans } from "@lingui/macro";
import { UiBox, UiSpinner } from "@smp/ui";
import { FC } from "react";

import { useQueryBillingFeatureProduct } from "@/queries/billing";

import { IProductDescriptionProps } from "../../product_description";

export const CompositionFeature: FC<{
  product: Extract<
    IProductDescriptionProps["product"],
    { type: "feature-subscription" }
  >;
}> = ({ product }) => {
  const { data: feature, isLoading } = useQueryBillingFeatureProduct({
    path: { id: product.feature },
  });

  if (isLoading) {
    return (
      <UiBox
        display="flex"
        height={40}
        justifyContent="center"
        alignItems="center"
      >
        <UiSpinner size={24} />
      </UiBox>
    );
  }

  if (!feature) {
    return null;
  }

  return (
    <UiBox display="flex" flexDirection="row">
      <UiBox flexGrow={1} pl={2}>
        {feature.name === "watermark_slot" ? (
          <Trans>Quantity</Trans>
        ) : (
          <Trans>Duration</Trans>
        )}
      </UiBox>
      <UiBox flexGrow={1} textAlign="right">
        {feature.name === "video_posting" ? product.period_days : 1}
      </UiBox>
    </UiBox>
  );
};
